import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  MenuCSSVars,
  SubsubmenuBoxCSSVars,
  MenuItemCSSVars,
  StylableHorizontalMenuDefinition,
  StylableHorizontalMenuProps,
  StylableHorizontalMenuCSSVars,
  StylableHorizontalMenuSdkData,
  StylableHorizontalMenuPropsCarmiData,
  CompLayout,
} from '../StylableHorizontalMenu.types';

const isHorizontallyDocked = (layout: CompLayout): boolean =>
  !!(layout.docked?.right && layout.docked?.left);

export const props = withCompInfo<
  StylableHorizontalMenuProps,
  StylableHorizontalMenuDefinition,
  StylableHorizontalMenuPropsCarmiData
>()(
  [
    'compProps',
    'compLayout',
    'compStylableClass',
    'isQaMode',
    'fullNameCompType',
  ],
  (
    { compProps, compLayout, compStylableClass, fullNameCompType, isQaMode },
    carmiProps,
  ) => {
    const { menuMode, submenuMode, isContainerStretched } = compProps;
    const { items, containerRootClassName } = carmiProps;

    return {
      menuMode,
      submenuMode,
      items,
      containerRootClassName,
      isStretched: isHorizontallyDocked(compLayout),
      isContainerStretched,
      className: compStylableClass,
      isQaMode,
      fullNameCompType,
    };
  },
);

export const css = withCompInfo<
  StylableHorizontalMenuCSSVars,
  StylableHorizontalMenuDefinition
>()(['compProps'], ({ compProps }): StylableHorizontalMenuCSSVars => {
  const { menuMode, submenuMode } = compProps;
  const isWrap = menuMode === 'wrap';
  const isFlyout = submenuMode === 'flyout';

  const menuCSSVars: MenuCSSVars = {
    '--menu-flex-wrap': isWrap ? 'wrap' : 'nowrap',
  };

  const subsubmenuBoxCSSVars: SubsubmenuBoxCSSVars = {
    '--subsubmenu-box-opacity': isFlyout ? 0 : 1,
    '--subsubmenu-box-pointer-events': isFlyout ? 'none' : 'inherit',
    '--subsubmenu-box-position': isFlyout ? 'absolute' : 'static',
    '--subsubmenu-box-show-animation': isFlyout ? 1 : 0,
  };

  const menuItemCSSVars: MenuItemCSSVars = {
    '--white-space': isFlyout ? 'nowrap' : 'normal',
    '--label-word-wrap': isFlyout ? 'normal' : 'break-word',
  };

  return {
    ...menuCSSVars,
    ...subsubmenuBoxCSSVars,
    ...menuItemCSSVars,
    ...(isWrap && {
      height: 'auto',
      'max-height': 'unset',
    }),
  };
});

export const sdkData = withCompInfo<
  StylableHorizontalMenuSdkData,
  StylableHorizontalMenuDefinition
>()(['pagesMap'], ({ pagesMap }) => ({
  pageList: pagesMap,
}));

export default createComponentMapperModel({ css, props, sdkData });
